import React from 'react';
import { autoId } from '../../utils/AutomationUtil';
import { dubLogoPrimaryUri, dubLogoReversedUri } from '../../assets';
import { WORKDAY_LOGO } from '../../messages';

interface WorkdayLogoProp {
    className?: string;
    isInverse?: boolean;
    onClick?: () => void | undefined;
    alt?: string;
}

export const WorkdayLogo = ({ className, isInverse, onClick, alt = WORKDAY_LOGO }: WorkdayLogoProp) => {
    return (
        <img
            {...autoId('workdayLogo')}
            alt={alt}
            src={isInverse ? dubLogoReversedUri : dubLogoPrimaryUri}
            className={className}
            onClick={onClick}
        />
    );
};
